import {
  FarmingAiri,
  FarmingBnb,
  FarmingBusd,
  FarmingKwt,
  FarmingMilky,
  FarmingOrai,
  FarmingSam,
} from '@/assets';
import { configs } from '@/configs';

export const POOL_ADDRESS = {
  '0x35C9Ba815ef454EfF61FBC651c2fEED3ED8B3576': '0xF7697Db76FBf4Ba5D22c0C72AB986cf751FBa3aF',
  '0x9cB4aD8b4D6BBa985f4EFE134427Ed1401345c4A': '0x3d35348aca6a2c0112f96980f9f7e55bee04e072',
  '0x9aC07D0D8a05A16C69Ba10127bF5ba618A63118C': '0xa325ad6d9c92b55a3fc5ad7e412b1518f96441c0',
  '0x016fD0227bDF7D019f59134f47CE04765Fe166cD': '0x7e2A35C746F2f7C240B664F1Da4DD100141AE71F',
  '0xB0Ea3Fe3b289C046Af84bc345267b08ebFd63437': '0x2a6CE1CC01627Ea7711FF5E4ed780df3fb527a65',
};

export const FARM_FACTORY_ADDRESS = '0xc8ac6D5e5EbD31a5889314274118aD787C7EB2Ca';
export const IGNORES = [
  '0x6A9DdC7Ba70C1Ecb4Da4d7D7e56FCb7d53270ca9',
  '0x70BB713493Bb356895B8c7b008C4B62c9ea630af',
  '0x01588CDdaceEdf0FBb9ddF7Dea6f009fb8607d4B',
  '0x142Ba459218CaFDCf8F98a5FA3e139F32fccec70',
];
export const IGNORES_NOT_KAWAII_TOKENS = [
  '0xA325Ad6D9c92B55A3Fc5aD7e412B1518F96441C0',
  '0x7e2A35C746F2f7C240B664F1Da4DD100141AE71F',
  '0x3D35348aCa6A2c0112f96980F9f7e55bEE04E072',
  '0xF7697Db76FBf4Ba5D22c0C72AB986cf751FBa3aF',
  '0x2a6CE1CC01627Ea7711FF5E4ed780df3fb527a65',
  '0x2a6CE1CC01627Ea7711FF5E4ed780df3fb527a65',
];
export const OLD_MILKY_ADDRESS = '0x19661223C71337121c58363152Df8f35EE4bE399';
export const NEW_MILKY_ADDRESS = '0x6fe3d0f096fc932a905accd1eb1783f6e4cec717';
export const NEW_MILKY_POOL_ADDRESS = '0x62F0183db0AD1f4d9178262d1f3b9029A9146B23';

export const POOLS = {
  '0x35C9Ba815ef454EfF61FBC651c2fEED3ED8B3576': 'ORAI-BNB',
  '0x9cB4aD8b4D6BBa985f4EFE134427Ed1401345c4A': 'AIRI-BNB',
  '0x9aC07D0D8a05A16C69Ba10127bF5ba618A63118C': 'ORAI',
  '0x016fD0227bDF7D019f59134f47CE04765Fe166cD': 'AIRI',
  '0xe450ED7bc4FbBbBb4e7612154b1F182A12751164': 'SamORAI-BNB',
  '0xB0Ea3Fe3b289C046Af84bc345267b08ebFd63437': 'SamORAI-BNB',
};

export const GTOKEN_POOLS = {
  '0xEFe47fad05e1B730DED8B2A26cF2254641BD5c0e': 'KWT-BNB',
  '0x257a8d1E03D17B8535a182301f15290F11674b53': 'KWT',
  '0x6fe3d0f096fc932a905accd1eb1783f6e4cec717': 'MILKY',
};
export const WBNB_ADDRESS = '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c';
export const ZERO_ADDRESS = '0x0000000000000000000000000000000000000000';
export const PANCAKE_FACTORY_ADDRESS = '0xca143ce32fe78f1f7019d7d551a6402fc5350c73';
export const SAMORAI_BNB_POOL = '0xe450ED7bc4FbBbBb4e7612154b1F182A12751164';
export const VAULTS = [
  '0xe450ED7bc4FbBbBb4e7612154b1F182A12751164',
  '0xB0Ea3Fe3b289C046Af84bc345267b08ebFd63437',
  '0x35C9Ba815ef454EfF61FBC651c2fEED3ED8B3576',
  '0x9cB4aD8b4D6BBa985f4EFE134427Ed1401345c4A',
  '0x016fD0227bDF7D019f59134f47CE04765Fe166cD',
  '0x9aC07D0D8a05A16C69Ba10127bF5ba618A63118C',
  '0x5BBaebD43d888f33540760FCC32Df72dF7F91F2F',
  '0xAf184B1367678547Af870d9838f605FD6A4460d1',
  '0x62F0183db0AD1f4d9178262d1f3b9029A9146B23',
];
export const KWT_ADDRESS = '0x257a8d1E03D17B8535a182301f15290F11674b53';
export const KWT_FARMING_LOCK_ADDRESS = '0x487856EcA2e3eb9D0FbdD622d7d0000647722537';
export const KWT_FARMING_LOCK_2_ADDRESS = '0x86DC50Ad8719bF89f0Ea49C9A21aA328bCa18313';

export const FARMING_IMAGES = {
  ORAI: FarmingOrai,
  BNB: FarmingBnb,
  SamORAI: FarmingSam,
  AIRI: FarmingAiri,
  BUSD: FarmingBusd,
  CRYPT: 'https://airight.io/images/CRYPT-logo.png',
  KWT: FarmingKwt,
  MILKY: FarmingMilky,
};

export const FARMING_IMAGES_URL = {
  ORAI: 'https://airight.io/images/orai-logo.png',
  BNB: FarmingBnb,
  SamORAI: 'https://airight.io/images/samorai-logo.png',
  AIRI: 'https://airight.io/images/aiRight-logo.png',
  BUSD: 'https://airight.io/images/BUSD-logo.png',
  CRYPT: 'https://airight.io/images/CRYPT-logo.png',
  KWT: 'https://airight.io/images/KWT-logo.png',
  MILKY: 'https://airight.io/images/MILKY-logo.png',
};
export const SAMORAI_POOL = '0xe450ED7bc4FbBbBb4e7612154b1F182A12751164';
export const SAMORAI_ADDRESS = '0x2a6CE1CC01627Ea7711FF5E4ed780df3fb527a65';
export const ADDRESSES = {
  '0x7e2a35c746f2f7c240b664f1da4dd100141ae71f': {
    type: 'NOT_LP',
  },
  '0x01588cddaceedf0fbb9ddf7dea6f009fb8607d4b': {
    type: 'LP',
  },
  '0x142ba459218cafdcf8f98a5fa3e139f32fccec70': {
    type: 'NOT_LP',
  },
  '0xefe47fad05e1b730ded8b2a26cf2254641bd5c0e': {
    type: 'LP',
  },
  '0x257a8d1E03D17B8535a182301f15290F11674b53': {
    type: 'NOT_LP',
  },
  '0x6fe3d0f096fc932a905accd1eb1783f6e4cec717': {
    type: 'NOT_LP',
  },
};

export const BUSD = '0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56'.toLowerCase();

export const TOKENS = {
  ORAI: '0xa325ad6d9c92b55a3fc5ad7e412b1518f96441c0',
  AIRI: '0x7e2a35c746f2f7c240b664f1da4dd100141ae71f',
  SamORAI: '0xE65B9e5fd7029169a81F13910F49c174d851f393',
  KWT: '0x257a8d1E03D17B8535a182301f15290F11674b53',
  CRYPT: '0x142Ba459218CaFDCf8F98a5FA3e139F32fccec70',
};

export const KWT_RELAY_ADDRESS = '0x1Cdb477AD8F6B0994782a6A39C57Bc1d6C5b78f7';
export const FARMING_RELAY_ADDRESS = '0x77F5872FB2deD020dCb22389B26fd321739Ec197';

export const AIRI_MIGRATE_INFO = {
  tokenAddress: configs.airiTokenContractBsc || '',
  name: "AIRI",
  decimals: 18,
  rewardToken: "0x7e2A35C746F2f7C240B664F1Da4DD100141AE71F",
  creatorAddress: "0x8658915E97797Ec938108b2D5f63be7E03d52E9f",
  migrateStakeAiriProxy: configs.migrateStakeAiri || '',
}
